import { darkTheme, lightTheme } from '@criteria-labs/react-editor'
import { useTheme } from 'next-themes'
import { DocumentStore } from '../documents/DocumentStore'
import { JSONDocument } from '../documents/JSONDocument'
import { JSONSchemaDocument } from '../documents/JSONSchemaDocument'
import { OpenAPIDocument } from '../documents/OpenAPIDocument'
import { SpectralRulesetDocument } from '../documents/SpectralRulesetDocument'

type JSONDocumentType = 'OpenAPIDocument' | 'JSONSchemaDocument' | 'SpectralRulesetDocument'

export const jsonDocumentTypeInfos: Record<JSONDocumentType, { title: string }> = {
  OpenAPIDocument: {
    title: 'OpenAPI'
  },
  JSONSchemaDocument: {
    title: 'JSON Schema'
  },
  SpectralRulesetDocument: {
    title: 'Spectral Ruleset'
  }
}

export function DocumentTypeIndicator({ document }: { document: JSONDocument }) {
  let { resolvedTheme } = useTheme()
  const editorTheme = resolvedTheme === 'dark' ? darkTheme : lightTheme

  const jsonDocumentType =
    document instanceof OpenAPIDocument
      ? 'OpenAPIDocument'
      : document instanceof JSONSchemaDocument
      ? 'JSONSchemaDocument'
      : document instanceof SpectralRulesetDocument
      ? 'SpectralRulesetDocument'
      : undefined

  return (
    <div className="shrink-0">
      <label htmlFor="jsonDocumentType" className="sr-only">
        Document Type
      </label>
      <select
        id="jsonDocumentType"
        name="jsonDocumentType"
        className="m-0 block w-[8rem] border-0 p-0.5 text-xs"
        style={{ backgroundColor: editorTheme.colors['editor.background'] }}
        value={jsonDocumentType ?? 'OpenAPIDocument'}
        onChange={(event) => DocumentStore.shared().setDocumentType(document, event.target.value as JSONDocumentType)}
      >
        {(Object.keys(jsonDocumentTypeInfos) as JSONDocumentType[]).map((jsonDocumentType) => (
          <option key={jsonDocumentType} value={jsonDocumentType}>
            {jsonDocumentTypeInfos[jsonDocumentType].title}
          </option>
        ))}
      </select>
    </div>
  )
}
